
function animationGsapInfoFooter() {
    // Registrar ScrollTrigger en GSAP
    gsap.registerPlugin(ScrollTrigger);
  
    // Seleccionar todas las secciones con la clase .section-featured-cards
    const sectionCards = document.querySelectorAll('.section-featured-cards');
  
	// Verifica si los elementos requeridos existen en la página
	if (!sectionCards) {
		return;
	}
    
    sectionCards.forEach((section) => {
        // Buscar todos los conjuntos de elementos en cada sección
        const images = section.querySelectorAll('.gsap-item-image img');
        const titles = section.querySelectorAll('.gsap-title');
        const texts = section.querySelectorAll('.gsap-text');
  
        images.forEach((image, index) => {
            // Crear una línea de tiempo independiente para cada conjunto de elementos
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section, // El trigger es la sección principal
                    start: "top bottom",
                    end: "top 20%",
                    scrub: true,
                    markers: false, // Cambia a true para depurar
                    once: true,
                }
            });
  
            // Animar cada conjunto de elementos con el mismo índice
            tl.from(image, {
                yPercent: 20,
                scale: 0,
                ease: "Power2.easeInOut",
                opacity: 0,
                transformOrigin: "center center"
            }, 'start');
  
            if (titles[index]) {
                tl.from(titles[index], {
                    yPercent: 20,
                    opacity: 0,
                    ease: "Power2.easeInOut",
                    transformOrigin: "center center"
                }, 'start');
            }
  
            if (texts[index]) {
                tl.from(texts[index], {
                    yPercent: 20,
                    opacity: 0,
                    ease: "Power2.easeInOut",
                    transformOrigin: "center center"
                }, 'start');
            }
        });
    });
  }
  
  animationGsapInfoFooter();